import Vue from 'vue'
import data_lang from '@/data/lang.json'
import data_items from '@/data/cards/item.json'
import data_heroes from '@/data/heroes.json'

const app = {

	state: {
		screen: 'home',
		account: {
			gold: 0,
			config: {
				lang: 'en',
			},
			collection: {
				heroes: [],
				cards: []
			}
		}
	},


	getters: {
		app: function(state) { return state },
		lang: function(state) { return state.account.config.lang },
		l: function(state) {
			return data_lang[state.account.config.lang]
		}
	},



	actions: {
		init_app: function({ commit, dispatch }) {
			var account = localStorage.getItem('drop-the-volunteer')
			
			if (account) {
				commit('EDIT_ACCOUNT', JSON.parse(account))
			}
			else {
				var heroes = []
				for (var i in data_heroes) {
					var bag = data_heroes[i].bag
					var hero = _.cloneDeep(data_heroes[i])
					hero.bag = []
					for (var j in bag) {
						var item = _.cloneDeep(_.find(data_items, { slug: bag[j] }))
						if (item) hero.bag.push(item)
					}
					heroes.push(hero)
				}
				commit('EDIT_ACCOUNT_COLLECTION', { heroes: heroes })
				dispatch('save_account')
			}
		},
		set_screen: function({ commit }, data) {
			commit('SET_APP_STATE', { screen: data.screen })
		},
		set_lang: function({ commit, dispatch }, data) {
			commit('EDIT_ACCOUNT_CONFIG', { lang: data.lang })
			dispatch('save_account')
		},
		edit_account_gold: function({ commit, state }, data) {
			commit('EDIT_ACCOUNT', { gold: state.account.gold + data.value })
		},
		unlock_hero: function({ commit, state, dispatch }, data) {
			if (data.hero.cost <= state.account.gold) {
				dispatch('edit_account_gold', { value: -data.hero.cost })
				commit('EDIT_ACCOUNT_HERO', { hero: data.hero, locked: false })
				dispatch('save_account')
			}
		},
		save_account: function({ state }, data) {
			localStorage.setItem('drop-the-volunteer', JSON.stringify(state.account))
		}
	},



	mutations: {
		SET_APP_STATE: function(state, data) {
			for (var i in data) {
				Vue.set(state, i, data[i])
			}
		},
		EDIT_ACCOUNT: function(state, data) {
			for (var i in data) {
				Vue.set(state.account, i, data[i])
			}
		},
		EDIT_ACCOUNT_CONFIG: function(state, data) {
			for (var i in data) {
				Vue.set(state.account.config, i, data[i])
			}
		},
		EDIT_ACCOUNT_COLLECTION: function(state, data) {
			for (var i in data) {
				Vue.set(state.account.collection, i, data[i])
			}
		},
		EDIT_ACCOUNT_HERO: function(state, data) {
			for (var i in data) {
				if (i != 'hero') Vue.set(data.hero, i, data[i])
			}
		},
	}

}

export default app